/**
 * 消费记录页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const consumeCommonConfig = {
  texts: {
    noRecord: 'No consumption record',
    noMore: 'No more ~',
    loading: 'Loading...',
  },
}
